(function () {
  'use strict';

  var FT_KEY = 'rbt_ft';
  var LT_KEY = 'rbt_lt';
  var TTL_MS = 30 * 24 * 60 * 60 * 1000;
  var GA4_DEFAULT = 'G-63ZELX03L4';
  var GA4_TIMEOUT_MS = 1500;
  var CHECKOUT_GA4_TIMEOUT_MS = 500;
  var ATTACH_DEBOUNCE_MS = 2000;
  var CHECKOUT_LOADING_RESET_MS = 8000;

  var CHECKOUT_SELECTOR =
    '#gokwik-buy-now, [data-gokwik-buy-now-trigger], .gokwik-checkout button, [onclick*="onCheckoutClick"], [onclick*="onBuyNowClick"]';

  var lastAttachAt = 0;
  var attachPromise = null;

  function getGa4MeasurementId() {
    if (window.gaTag && window.gaTag.ga4) {
      return window.gaTag.ga4;
    }
    return GA4_DEFAULT;
  }

  function parseUtms(search) {
    var params = new URLSearchParams(search || window.location.search);
    var src = (params.get('utm_source') || '').trim();
    var med = (params.get('utm_medium') || '').trim();

    if (!src && !med) {
      return null;
    }

    return {
      src: src,
      med: med,
      cmp: (params.get('utm_campaign') || '').trim(),
      id: (params.get('utm_id') || '').trim(),
      cnt: (params.get('utm_content') || '').trim(),
      trm: (params.get('utm_term') || '').trim(),
    };
  }

  function normalizeHost(hostname) {
    return (hostname || '').replace(/^www\./i, '').toLowerCase();
  }

  function isInternalReferrerHost(host) {
    if (!host) {
      return true;
    }

    if (host === normalizeHost(window.location.hostname)) {
      return true;
    }

    return (
      host === 'rabitat.com' ||
      host.endsWith('.myshopify.com') ||
      host === 'shopify.com' ||
      host.endsWith('.shopify.com') ||
      host.endsWith('.shopifycdn.com') ||
      host.endsWith('.shopifycloud.com')
    );
  }

  function parseReferrer(referrer) {
    if (!referrer) {
      return null;
    }

    try {
      var url = new URL(referrer);
      var host = normalizeHost(url.hostname);

      if (isInternalReferrerHost(host)) {
        return null;
      }

      if (/google\.|bing\.|yahoo\.|duckduckgo\.|baidu\./.test(host)) {
        var engine = host.split('.')[0];
        if (engine === 'google' || engine === 'bing' || engine === 'yahoo') {
          return {
            src: engine,
            med: 'organic',
            cmp: '',
            id: '',
            cnt: '',
            trm: '',
          };
        }
      }

      if (/facebook\.|instagram\.|fb\.com/.test(host)) {
        return {
          src: 'facebook',
          med: 'referral',
          cmp: '',
          id: '',
          cnt: '',
          trm: '',
        };
      }

      return {
        src: host,
        med: 'referral',
        cmp: '',
        id: '',
        cnt: '',
        trm: '',
      };
    } catch (error) {
      return null;
    }
  }

  function buildTouch(source) {
    if (!source) {
      return null;
    }

    return {
      src: source.src || '',
      med: source.med || '',
      cmp: source.cmp || '',
      id: source.id || '',
      cnt: source.cnt || '',
      trm: source.trm || '',
      at: new Date().toISOString(),
      landing: window.location.pathname + window.location.search,
    };
  }

  function currentTouch() {
    return buildTouch(parseUtms()) || buildTouch(parseReferrer(document.referrer));
  }

  function readTouch(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) {
        return null;
      }

      var parsed = JSON.parse(raw);
      if (!parsed || !parsed.at) {
        return null;
      }

      if (Date.now() - new Date(parsed.at).getTime() > TTL_MS) {
        localStorage.removeItem(key);
        return null;
      }

      return parsed;
    } catch (error) {
      return null;
    }
  }

  function writeTouch(key, touch) {
    if (!touch) {
      return;
    }

    try {
      localStorage.setItem(key, JSON.stringify(touch));
    } catch (error) {}
  }

  function captureOnLoad() {
    var touch = currentTouch();
    if (!touch) {
      return;
    }

    if (!readTouch(FT_KEY)) {
      writeTouch(FT_KEY, touch);
    }

    writeTouch(LT_KEY, touch);
  }

  function emptyFtAttrs() {
    return {
      _ft_src: '',
      _ft_med: '',
      _ft_cmp: '',
      _ft_id: '',
      _ft_cnt: '',
      _ft_trm: '',
      _ft_at: '',
    };
  }

  function emptyLtAttrs() {
    return {
      _lt_src: '',
      _lt_med: '',
      _lt_cmp: '',
      _lt_id: '',
      _lt_cnt: '',
      _lt_trm: '',
    };
  }

  function touchToFtAttrs(touch) {
    if (!touch) {
      return emptyFtAttrs();
    }

    return {
      _ft_src: touch.src || '',
      _ft_med: touch.med || '',
      _ft_cmp: touch.cmp || '',
      _ft_id: touch.id || '',
      _ft_cnt: touch.cnt || '',
      _ft_trm: touch.trm || '',
      _ft_at: touch.at || '',
    };
  }

  function touchToLtAttrs(touch) {
    if (!touch) {
      return emptyLtAttrs();
    }

    return {
      _lt_src: touch.src || '',
      _lt_med: touch.med || '',
      _lt_cmp: touch.cmp || '',
      _lt_id: touch.id || '',
      _lt_cnt: touch.cnt || '',
      _lt_trm: touch.trm || '',
    };
  }

  function readCookie(name) {
    var escaped = name.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    var match = document.cookie.match(new RegExp('(?:^|; )' + escaped + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function getGaClientIdFromCookie() {
    var value = readCookie('_ga');
    if (!value) {
      return '';
    }

    var parts = value.split('.');
    if (parts.length >= 4) {
      return parts.slice(-2).join('.');
    }

    return '';
  }

  function getGaSessionIdFromCookie(measurementId) {
    var suffix = (measurementId || '').replace(/^G-/, '');
    if (!suffix) {
      return '';
    }

    var value = readCookie('_ga_' + suffix);
    if (!value) {
      return '';
    }

    var segments = value.split('$');
    for (var i = 0; i < segments.length; i++) {
      if (segments[i].charAt(0) === 's' && segments[i].length > 1) {
        return segments[i].slice(1);
      }
    }

    return '';
  }

  function getGa4IdsFromCookies(measurementId) {
    return {
      cid: getGaClientIdFromCookie(),
      sid: getGaSessionIdFromCookie(measurementId),
    };
  }

  function getGa4Ids(measurementId, timeoutMs) {
    var cookieIds = getGa4IdsFromCookies(measurementId);

    return new Promise(function (resolve) {
      var result = { cid: cookieIds.cid, sid: cookieIds.sid };
      var settled = false;

      function finish() {
        if (settled) {
          return;
        }
        settled = true;

        if (!result.cid) {
          result.cid = getGaClientIdFromCookie();
        }
        if (!result.sid) {
          result.sid = getGaSessionIdFromCookie(measurementId);
        }

        resolve(result);
      }

      if (typeof window.gtag !== 'function') {
        finish();
        return;
      }

      window.setTimeout(finish, timeoutMs || GA4_TIMEOUT_MS);

      var pending = 2;

      function markDone() {
        pending -= 1;
        if (pending <= 0) {
          finish();
        }
      }

      try {
        window.gtag('get', measurementId, 'client_id', function (clientId) {
          if (clientId) {
            result.cid = clientId;
          }
          markDone();
        });
        window.gtag('get', measurementId, 'session_id', function (sessionId) {
          if (sessionId) {
            result.sid = String(sessionId);
          }
          markDone();
        });
      } catch (error) {
        finish();
      }
    });
  }

  function postCartAttributes(attributes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify({ attributes: attributes }),
    }).catch(function () {
      return null;
    });
  }

  function buildOrderAttributes(gaIds) {
    var firstTouch = readTouch(FT_KEY);
    var lastTouch = readTouch(LT_KEY);

    return Object.assign(
      {
        _ga_cid: (gaIds && gaIds.cid) || '',
        _ga_sid: (gaIds && gaIds.sid) || '',
        _landing: (firstTouch && firstTouch.landing) || window.location.pathname + window.location.search,
      },
      touchToFtAttrs(firstTouch),
      touchToLtAttrs(lastTouch)
    );
  }

  function rbtAttachAcquisition(options) {
    var opts = options || {};
    var timeoutMs = opts.timeoutMs || GA4_TIMEOUT_MS;
    var now = Date.now();

    if (attachPromise && now - lastAttachAt < ATTACH_DEBOUNCE_MS) {
      return attachPromise;
    }

    lastAttachAt = now;
    attachPromise = getGa4Ids(getGa4MeasurementId(), timeoutMs)
      .then(function (gaIds) {
        return postCartAttributes(buildOrderAttributes(gaIds));
      })
      .catch(function () {
        return postCartAttributes(buildOrderAttributes({ cid: '', sid: '' }));
      })
      .finally(function () {
        window.setTimeout(function () {
          if (Date.now() - lastAttachAt >= ATTACH_DEBOUNCE_MS) {
            attachPromise = null;
          }
        }, ATTACH_DEBOUNCE_MS);
      });

    return attachPromise;
  }

  function isGokwikReady() {
    return typeof window.onBuyNowClick === 'function' || typeof window.onCheckoutClick === 'function';
  }

  function invokeGokwikCheckout(button) {
    if (button.id === 'gokwik-buy-now' || button.hasAttribute('data-gokwik-buy-now-trigger')) {
      return false;
    }

    if (button.closest('.gokwik-checkout') && typeof window.onCheckoutClick === 'function') {
      window.onCheckoutClick(button);
      return true;
    }

    return false;
  }

  function proceedWithCheckout(button) {
    function runCheckout() {
      if (button.id === 'gokwik-buy-now' || button.hasAttribute('data-gokwik-buy-now-trigger')) {
        return;
      }

      if (invokeGokwikCheckout(button)) {
        return;
      }

      button.dataset.rbtAcquisitionHandled = 'true';
      button.click();
    }

    if (isGokwikReady()) {
      runCheckout();
      return;
    }

    if (window.RabitatDeferredGokwik && typeof window.RabitatDeferredGokwik.load === 'function') {
      window.RabitatDeferredGokwik.load()
        .then(runCheckout)
        .catch(function () {
          runCheckout();
        });
      return;
    }

    runCheckout();
  }

  function setCheckoutButtonLoading(button, isLoading) {
    if (!button) return;

    var loader = button.querySelector('#btn-loader, .addloadr');

    if (isLoading) {
      if (button.dataset.rbtCheckoutLoading === 'true') return;
      button.dataset.rbtCheckoutLoading = 'true';
      button.setAttribute('aria-busy', 'true');
      button.classList.add('disabled', 'is-checkout-loading');
      button.disabled = true;
      if (loader) loader.style.display = 'flex';
      return;
    }

    if (button.dataset.rbtCheckoutLoading !== 'true') return;
    delete button.dataset.rbtCheckoutLoading;
    button.removeAttribute('aria-busy');
    button.classList.remove('disabled', 'is-checkout-loading');
    button.disabled = false;
    if (loader) loader.style.display = '';
  }

  function runPreCheckoutTasks() {
    var tasks = [
      rbtAttachAcquisition({ timeoutMs: CHECKOUT_GA4_TIMEOUT_MS }).catch(function () {
        return null;
      }),
    ];

    if (window.RabitatCart && typeof window.RabitatCart.sanitizeGiftLinesBeforeCheckout === 'function') {
      tasks.push(
        window.RabitatCart.sanitizeGiftLinesBeforeCheckout().catch(function () {
          return null;
        })
      );
    }

    return Promise.all(tasks);
  }

  function bindCheckoutCapture() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest(CHECKOUT_SELECTOR);
        if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') {
          return;
        }

        if (button.dataset.rbtAcquisitionHandled === 'true') {
          delete button.dataset.rbtAcquisitionHandled;
          return;
        }

        if (button.dataset.rbtCheckoutLoading === 'true') {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }

        setCheckoutButtonLoading(button, true);

        var resetLoadingTimer = window.setTimeout(function () {
          setCheckoutButtonLoading(button, false);
        }, CHECKOUT_LOADING_RESET_MS);

        runPreCheckoutTasks()
          .finally(function () {
            proceedWithCheckout(button);
            window.clearTimeout(resetLoadingTimer);
            window.setTimeout(function () {
              setCheckoutButtonLoading(button, false);
            }, 600);
          });
      },
      true
    );
  }

  window.rbtAttachAcquisition = rbtAttachAcquisition;

  captureOnLoad();
  bindCheckoutCapture();
})();
